namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class GAdmVyberovaSkupinaVyberDialog extends GContentBase {
        private typ_obj: number;
        private grid: JQuery<HTMLElement>;

        prepareContent() {
            this.init();
        }

        private init() {
            this.createForm();
            this.createTabs();
        }

        private createForm() {
            var form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1" })
                .addRow("jres:33000432").addField("gselectbox", Gordic.Prefabs.Select.admWflsblk(), {
                    name: "vyberovaSkupina",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required"
                })
            $("<div>").appendTo(this.element).gform("createFrom", form);
        }

        private createTabs() {
            var tab = $("<div>").gtab({
                title: "jres:33000437",
                opened: true,
                locked: true
            })
            this.grid = $("<div>").appendTo(tab).gautofit({ resizersOnTab: true }).ggrid({
                multi: true,
            })
        }
    }
}